/**
 * License-proxy endpoint (SP2). The deployed Cloudflare Worker's URL, supplied at
 * build time via `VITE_LICENSE_API_URL`. While empty (the default), the app uses
 * the local stub validator only — no remote calls — so the build runs offline and
 * tests are unaffected. Set it once the Worker (cue-forge-332.2) is deployed.
 */
export const LICENSE_API_URL: string =
  (import.meta.env.VITE_LICENSE_API_URL as string | undefined) ?? '';

/**
 * Whether the **local** stub validator (the in-bundle checksum + the bundled
 * test key) is trusted to grant Pro (cue-forge-sdv.1). It must NOT be on a real
 * production build, where Pro can only come from the remote (Lemon Squeezy)
 * validator — otherwise anyone can mint a key from the shipped checksum and
 * unlock the paid tier for free.
 *
 * So it is on for dev (`import.meta.env.DEV`) and unit tests (mode `test`), and
 * OFF for a production build unless explicitly re-enabled with
 * `VITE_ALLOW_LOCAL_LICENSE=true`. The e2e suite sets that flag (see
 * `playwright.config.ts`) because it previews a production build but must keep
 * the DEV_KEY pro-gate flow working offline. NEVER set it in `.env.production`.
 */
export const ALLOW_LOCAL_LICENSE: boolean =
  !import.meta.env.PROD || import.meta.env.VITE_ALLOW_LOCAL_LICENSE === 'true';
